export default __webpack_public_path__ + "static/media/closet5-after2-2048w.ea669d5e.png";